import { useState } from 'react';
import { useAppContext } from '../../context/AppContext';
import ClientForm from './ClientForm';

export default function ClientTable() {
    const { clients, deleteClient } = useAppContext();
    const [editingClient, setEditingClient] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);

    const handleEdit = (client) => {
        setEditingClient(client);
        setShowEditModal(true);
    };

    const handleEditComplete = () => {
        setEditingClient(null);
        setShowEditModal(false);
    };

    const handleDelete = async (id, name) => {
        if (window.confirm(`Tem certeza que deseja excluir o cliente "${name}"?`)) {
            try {
                await deleteClient(id);
            } catch (err) {
                alert('Erro ao excluir cliente');
            }
        }
    };

    if (!clients.length) {
        return (
            <div className="alert alert-light border">
                <div className="text-center py-4">
                    <div className="fs-1 mb-2">👥</div>
                    <h5>Nenhum cliente cadastrado</h5>
                    <p className="text-muted mb-0">
                        Cadastre seus clientes para facilitar a criação de pedidos
                    </p>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="card shadow-sm">
                <div className="card-body">
                    <h2 className="h5 mb-3">Lista de Clientes ({clients.length})</h2>
                    <div className="table-responsive">
                        <table className="table table-hover align-middle">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Contato</th>
                                    <th>Endereço</th>
                                    <th className="text-end">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {clients.map((client) => (
                                    <tr key={client.id}>
                                        <td>
                                            <div className="fw-semibold">{client.name}</div>
                                            {client.notes && (
                                                <div className="small text-muted">{client.notes}</div>
                                            )}
                                        </td>
                                        <td>
                                            {client.phone && (
                                                <div className="small">📱 {client.phone}</div>
                                            )}
                                            {client.email && (
                                                <div className="small">📧 {client.email}</div>
                                            )}
                                        </td>
                                        <td>
                                            {client.address && (
                                                <div className="small">
                                                    {client.address}
                                                    {client.neighborhood && `, ${client.neighborhood}`}
                                                    {client.city && ` - ${client.city}`}
                                                </div>
                                            )}
                                            {client.reference && (
                                                <div className="small text-muted">
                                                    📍 {client.reference}
                                                </div>
                                            )}
                                        </td>
                                        <td className="text-end">
                                            <button
                                                className="btn btn-sm btn-outline-primary me-1"
                                                onClick={() => handleEdit(client)}
                                                title="Editar"
                                            >
                                                ✏️
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => handleDelete(client.id, client.name)}
                                                title="Excluir"
                                            >
                                                🗑️
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Modal de edição */}
            {showEditModal && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body p-0">
                                <ClientForm
                                    editingClient={editingClient}
                                    onEditComplete={handleEditComplete}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
